import { createContext, useContext, type ReactNode } from "react";
import { useMediaQuery, useTheme } from "@mui/material";

/** Contexto de layout da tela de sumário — mobile usa cards + ScreenMobile. */
const EhrRecordsLayoutContext = createContext(false);

export function EhrRecordsLayoutProvider({
  isMobileLayout,
  children,
}: {
  isMobileLayout: boolean;
  children: ReactNode;
}) {
  return (
    <EhrRecordsLayoutContext.Provider value={isMobileLayout}>
      {children}
    </EhrRecordsLayoutContext.Provider>
  );
}

/** true quando a página EHRRecords está no layout mobile (ScreenMobile). */
export function useEhrRecordsMobileLayout(): boolean {
  return useContext(EhrRecordsLayoutContext);
}

/**
 * true quando a UI deve usar cards em vez de tabelas:
 * contexto EHR mobile OU viewport abaixo de md (ex.: ViewDocs, PatientDocs estreito).
 */
export function usePreferMobileCards(): boolean {
  const fromEhrContext = useEhrRecordsMobileLayout();
  const theme = useTheme();
  const fromBreakpoint = useMediaQuery(theme.breakpoints.down("md"));
  return fromEhrContext || fromBreakpoint;
}
